import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAch = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-1dec5e6a-36fc-4990-82a0-4ae7012257e0",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 116.18 116.18",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M37.46,62.71l-13.86,21.47h5.31l2.8-4.6h9.99l1.01,4.6h4.97l-5.28-21.47h-4.94ZM34,75.81l5.05-8.28,1.82,8.28h-6.86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M57.47,68.98c.7-.77,1.55-1.36,2.53-1.78.98-.42,2.07-.63,3.28-.63s2.21.21,3.07.64c.86.43,1.56,1.05,2.12,1.87l3.59-2.95c-.76-1.23-1.87-2.17-3.34-2.82-1.47-.65-3.17-.98-5.09-.98s-3.82.33-5.44.98c-1.62.66-3.03,1.56-4.2,2.72-1.18,1.16-2.09,2.52-2.73,4.09-.64,1.58-.97,3.27-.97,5.09s.43,3.46,1.29,4.86,2.08,2.5,3.66,3.28c1.58.79,3.47,1.18,5.66,1.18,1.84,0,3.53-.29,5.08-.87,1.54-.58,2.88-1.53,4-2.84l-2.94-3.01c-.78.86-1.65,1.49-2.61,1.89-.96.4-1.99.6-3.1.6-1.27,0-2.35-.22-3.25-.67-.9-.45-1.59-1.08-2.06-1.89-.47-.81-.7-1.75-.7-2.84,0-1.15.18-2.23.55-3.25.37-1.02.9-1.92,1.61-2.68Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "currentColor",
			points: "91.1 62.71 89.41 71.18 79.68 71.18 81.38 62.71 76.38 62.71 72.08 84.18 77.08 84.18 78.84 75.38 88.57 75.38 86.81 84.18 91.78 84.18 96.07 62.71 91.1 62.71"
		})
	] }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M75.28,27.96v2.3l-2.34.06c-.04.52-.36.88-.84,1.05l-28.08.03c-.56-.06-1.06-.57-1.05-1.15h-2.3v-2.3l17.33-6.87,17.28,6.87Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M75.28,50.87v2.43h-34.61c.16-1.19-.58-3.1,1.05-3.45h32.38c.64.06,1,.43,1.18,1.02Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M49.86,32.56v13.75l.1.1h2.16l.1-.1v-13.75h4.6v13.85h2.3v-13.85h4.6v13.85h2.3v-13.85h4.6v13.75l.1.1h1.28c.22,0,.91.56.91.78v1.52h-29.94v-1.39c0-.27.66-.91.91-.91h1.39v-13.85h4.6Z"
		})
	] })]
});
export default SvgAch;
